import React, { useEffect } from 'react';
import './modal.css';

const Modal = ({ isOpen, onClose, children, closeButton = true, triggerFonction, onMountFunction, width }) => {
    const modalClass = isOpen ? 'modal-overlay open' : 'modal-overlay';

    useEffect(() => {
        if (triggerFonction) {
            onMountFunction();
        }
    }, []);

    // Close on Escape key
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape' && isOpen && onClose) onClose();
        };
        document.addEventListener('keydown', handleEscape);
        return () => document.removeEventListener('keydown', handleEscape);
    }, [isOpen, onClose]);

    return (
        <div className={modalClass} onClick={(e) => { if (e.target === e.currentTarget && onClose) onClose(); }}>
            <div className="modal-container" style={{width: width || null}}>
                {
                    closeButton !== false && (
                        <button className="close-button" onClick={onClose}>
                            ✕
                        </button>
                    )
                }
                {children}
            </div>
        </div>
    );
};

export default Modal;
